module.exports = __webpack_public_path__ + "img/5-2.1ef5ff15.png";